import React from "react";
import { Box, Typography, Divider, Grid } from "@mui/material";
import { shades } from "../theme";

const addressToString = (address) =>
  address
    ? `${address.firstName} ${address.lastName}, ${address.street1}${address.street2 ? ", " + address.street2 : ""}, ${address.city}, ${address.state}, ${address.zipCode}, ${address.country}`
    : "";

const OrderSummary = ({ cart, values }) => {
  const total = cart.reduce(
    (sum, item) => sum + item.price * (item.count || 1),
    0
  );
  return (
    <Box
      sx={{
        border: `1.5px solid ${shades.neutral[200]}`,
        borderRadius: "16px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        p: 3,
        mb: 4,
        background: "#fff",
        maxWidth: 700,
        mx: "auto",
      }}
    >
      <Typography variant="h6" fontWeight={700} mb={2}>
        Order Summary
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box mb={2}>
        {cart.map((item) => (
          <Grid
            container
            spacing={1}
            alignItems="center"
            key={item.id}
            sx={{ mb: 1 }}
          >
            <Grid item xs={6}>
              <Typography fontWeight={600}>{item.Name}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography color="text.secondary">x{item.count || 1}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography fontWeight={600}>${item.price}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography fontWeight={700}>Total</Typography>
        <Typography fontWeight={700}>${total.toFixed(2)}</Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Typography fontWeight={600} mb={1}>
        Contact Email
      </Typography>
      <Typography mb={2}>{values.email}</Typography>
      <Typography fontWeight={600} mb={1}>
        Billing Address
      </Typography>
      <Typography mb={2}>{addressToString(values.billingAddress)}</Typography>
      <Typography fontWeight={600} mb={1}>
        Shipping Address
      </Typography>
      <Typography mb={2}>{addressToString(values.shippingAddress)}</Typography>
    </Box>
  );
};

export default OrderSummary;
